import { Injectable, signal } from '@angular/core';

const HIDDEN_STORAGE_KEY = 'si-inb-info-bar-hidden';

const readStoredHidden = (): boolean => {
    try {
        const stored = localStorage.getItem(HIDDEN_STORAGE_KEY);
        // Hidden by default: the inbox gets the whole viewport unless the user opts in.
        return stored === null ? true : stored === 'true';
    } catch {
        return true;
    }
};

/**
 * Visibility of the inbox summary bar (`si-inb-info-bar`). Lives at root so the
 * global topbar can offer the "show / hide summary" control while the bar itself
 * (inside the inbox card) can dismiss itself. Persisted per browser.
 */
@Injectable({ providedIn: 'root' })
export class InbInfoBarStateService {
    readonly isHidden = signal(readStoredHidden());

    /** Mirrored by the bar so the topbar can badge the toggle while the bar is hidden. */
    readonly unreadCount = signal(0);

    toggle() {
        this.setHidden(!this.isHidden());
    }

    hide() {
        this.setHidden(true);
    }

    show() {
        this.setHidden(false);
    }

    private setHidden(hidden: boolean) {
        this.isHidden.set(hidden);
        try {
            localStorage.setItem(HIDDEN_STORAGE_KEY, String(hidden));
        } catch {
            /* storage unavailable: state stays in memory */
        }
    }
}
